import { useMemo } from "react";

import clsx from "clsx";

import { MilestonesGrid } from "features/milestones/components";

export const CreatorMilestones = ({ creator_id, className, ...props }) => {
  const classes = clsx("creator-milestones", className);
  const filterParams = useMemo(() => {
    return {
      user_id: creator_id,
    };
  }, [creator_id]);
  return (
    <MilestonesGrid
      filterParams={filterParams}
      className={classes}
      gridId="creator-milestones"
      excludeDataSources="creator"
    />
  );
};
